import { authResource } from './Auth';
export const OrganizationEncryptionGeofencingResource = authResource({
    path: '/organizations/:organizationId/encryptions/geofencing/:geofencingId?',
    schema: {}
}).extend('update', {
    body: {
        encryptionGUIDs: [],
        geoCountryIds: []
    },
    schema: undefined
});
